import { ApolloProvider } from "@apollo/client/react";
import { ReactNode, useEffect, useState } from "react";

import { buildClient, buildLink } from "@smart/manage-gql-client-dom";

import { useUser } from "./user";

export type ClientProviderProps = { children: ReactNode };

export const ClientProvider = ({ children }: ClientProviderProps) => {
  const { refresh, token, idToken } = useUser();
  const [client] = useState(() => buildClient({ token, idToken, refresh }));
  useEffect(() => {
    client.setLink(buildLink({ token, idToken, refresh }));
  }, [token, refresh]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
